import React from "react";
// import numeral from "numeral";

class BigMoney extends React.Component {
  render() {
    // const displayValue = numeral(this.props.value).format('0.0a');
    let displayValue =
      Math.abs(Number(this.props.value)) >= 1.0e9
        ? (Math.abs(Number(this.props.value)) / 1.0e9)
            .toString()
            .split(".")[1] !== undefined &&
          (Math.abs(Number(this.props.value)) / 1.0e9)
            .toString()
            .split(".")[1]
            .slice(0, 1) === "0"
          ? (Math.abs(Number(this.props.value)) / 1.0e9)
              .toString()
              .split(".")[0] + "B"
          : (Math.abs(Number(this.props.value)) / 1.0e9)
              .toString()
              .split(".")[1] !== undefined &&
            (Math.abs(Number(this.props.value)) / 1.0e9)
              .toString()
              .split(".")[1]
              .slice(0, 1) !== "0"
          ? (Math.abs(Number(this.props.value)) / 1.0e9)
              .toString()
              .match(/^-?\d+(?:\.\d{0,1})?/)[0] + "B"
          : Math.abs(Number(this.props.value)) / 1.0e9 + "B"
        : // ? (Math.ceil(Number(this.props.value)) / 1.0e+9).toFixed(1) + "B"
        // Six Zeroes for Millions
        Math.abs(Number(this.props.value)) >= 1.0e6
        ? (Math.abs(Number(this.props.value)) / 1.0e6).toString().split(".")[0]
            .length === 3
          ? (Math.abs(Number(this.props.value)) / 1.0e6)
              .toString()
              .split(".")[0] + "M"
          : (Math.abs(Number(this.props.value)) / 1.0e6)
              .toString()
              .match(/^-?\d+(?:\.\d{0,1})?/)[0] + "M"
        : // console.warn(billion.slice(0,4) +"B")
        // Three Zeroes for Thousands
        Math.abs(Number(this.props.value)) >= 1.0e3
        ? (Math.abs(Number(this.props.value)) / 1.0e3)
            .toString()
            .split(".")[1] !== undefined &&
          (Math.abs(Number(this.props.value)) / 1.0e3)
            .toString()
            .split(".")[1]
            .slice(0, 1) === "0"
          ? (Math.abs(Number(this.props.value)) / 1.0e3)
              .toString()
              .split(".")[0] + "K"
          : (Math.abs(Number(this.props.value)) / 1.0e3)
              .toString()
              .split(".")[1] !== undefined &&
            (Math.abs(Number(this.props.value)) / 1.0e3)
              .toString()
              .split(".")[1]
              .slice(0, 1) !== "0"
          ? (Math.abs(Number(this.props.value)) / 1.0e3)
              .toString()
              .match(/^-?\d+(?:\.\d{0,1})?/)[0] + "K"
          : Math.abs(Number(this.props.value)) / 1.0e3 + "K"
        : Math.abs(Number(this.props.value)) >= 1.0e12
        ? Math.abs(Number(this.props.value)) / 1.0e12 + "T"
        : Math.abs(Number(this.props.value));
    return <span className="bigMoney">${displayValue}</span>;
  }
}

export default BigMoney;
